<template>
    <div class="templateThree" v-if="data.cardImgIcon">
        <!-- <div class="container"> -->
            <div class="mainContents mx-auto">
                <!-- {{ this.data.cardData._id }}
                {{ this.user_id }} -->
                <section class="vcard__banner w-100 position-relative">
                    <!-- <img src="https://www.karti.io/uploads/vcards/covers/1750/WhatsApp-Image-2022-08-15-at-1.22.51-PM.jpeg" class="img-fluid banner-image" alt="banner"> -->
                    <router-link :to="'/S/' + $route.params.smartCardID">
                         <i class="fa-solid fa-arrow-left">    </i> 
                        </router-link>
                    <img :src="imgUrl + '/' + data.cardImgIcon.backgroundImg" class="img-fluid banner-image" alt="banner">
                </section>

                <section class="vcard__profile d-flex align-items-center px-4 flex-sm-row flex-column mx-auto">
                    <div class="vcard__avatar">
                        <!-- <img src="https://www.karti.io/uploads/vcards/profiles/1749/WhatsApp-Image-2022-08-15-at-1.22.53-PM.jpeg" class="rounded-circle"> -->
                        <img :src="imgUrl + '/' + data.cardImgIcon.profileImg" class="rounded-circle">
                    </div>
                    <div class="vcard__position d-flex flex-column mx-sm-4 mt-sm-5 mt-2">
                        <div class="vcard_details d-flex flex-column">
                            <h4 class="avatar-name text-sm-start text-center">{{ data.cardData.details.firstName }} {{ data.cardData.details.lastName }}</h4>
                            <span class="avatar-designation text-sm-start text-center">{{ data.cardData.details.jobTitle }}</span>
                        </div>
                    </div>
                </section>

                <section class="vcard__catalogue">
                    <h4>{{ data.cardData.details.defaultLanguage == "English" ? "Catalogues": "كتالوجات" }}</h4>

                    <div class="contents">
                        <div class="content" v-for="(catalogue, index) in data.cardCatalogue" :key="index">
                            <p>{{ catalogue.name }}</p>
                            <span><i class="fa-solid fa-file-pdf" @click="catalogueRedirection(catalogue.cataloguePDF)"></i></span>
                        </div>
                    </div>
                </section>

                <section class="copyright">
                    <span class="line"></span>
                    <p>Copyright &copy; {{ new Date().getFullYear() }} istpacket. All Rights Reserved</p>
                </section>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
import axios from 'axios'
import APIs from '../../../../../config'

export default {
    data() {
        return {
            data: "",
            imgUrl: APIs.API_IMAGES,
            value: 'https://app.smartcard.womi.ma/S/'+this.$route.params.smartCardID,
            size: 150,
            user_id: localStorage.getItem('admin_id'),
            name: "",
            email: "",
            phone: "",
            message: ""
        }
    },
    async created() {
        await this.getCardCurrentData()
        console.log("created", this.data._id)
        console.log("created", this.user_id)
    },
    methods: {
        sendMessage() {
                const fd = {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    message: this.message
                }

                axios.post(`${APIs.API_URL}/contact/${this.data.cardData._id}/${this.user_id}`, fd)
                .then(() => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Added",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }).then(() => {
                    this.resetForm()
                })
                .catch( (error) => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                });
        },
        resetForm() {
            this.name = ""
            this.email = ""
            this.phone = ""
            this.message = ""
        },
        reddirectTo(url) {
            if(/^(http[s]?:\/\/)/.test(url)) {
                window.open(url, '_blank');
            }
            else {
                window.open("https://" + url, '_blank');
            }
        },
        getCardCurrentData() {
            axios.get(`${APIs.API_URL}/card/smartCard/${this.$route.params.smartCardID}`)
            .then(res => {
                this.data = res.data
                const idtemplate = this.data.cardData.IdfromTemplate
                console.log("data id = ",idtemplate);
                // methode to get idtemplate :
                this.emitIdTemplate(idtemplate) 
            })
        },
        catalogueRedirection(url) {
            window.open(APIs.API_IMAGES + '/' + url, '_blank');
        },
        addContact() {
            let formData = {
                FN: this.data.cardData.details.firstName,
                LN: this.data.cardData.details.lastName,
                Org: this.data.cardData.details.company,
                Phone: this.data.cardData.details.phone,
                Title: this.data.cardData.details.jobTitle,
                Url: `https://app.smartcard.womi.ma/S/${this.$route.params.smartCardID}`,
                Notes: this.data.cardData.description,
            }
            axios.post(`${APIs.API_URL}/card/vcf/${this.$route.params.smartCardID}`, formData)
            .then(res => {
                // console.log(res.data)
                window.open(`${APIs.API_IMAGES}/${res.data}`, "_blank")
            })
        },
        emitIdTemplate(idtemplate){
                this.$emit('idtemplatechanged',idtemplate)
                console.log("Emitting idTemplate 1:", idtemplate);
        }
    },
}
</script>

<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Shrikhand&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    $main_color: #3C3942;
    $main_font: 'Poppins', sans-serif;
    $number_font: 'Shrikhand', cursive;

    .templateThree {
        font-family: $main_font;
        .mainContents {
            background-color: #2E2834;
            max-width: 576px;
            min-height: 100vh;

            @mixin card_products_services($category) {
                padding: 5% 20% 8%;
               /* @if $category == service {
                    background-image: url(../../../../assets/img/backgroundImg1.png), url(../../../../assets/img/backgroundImg2.png), url(../../../../assets/img/backgroundImg3.png);
                    background-position: -15% 15%, -10% 100%, 110% 60%;
                }
                @if $category == product {
                    background-image: url(../../../../assets/img/backgroundImg4.png), url(../../../../assets/img/backgroundImg5.png), url(../../../../assets/img/backgroundImg6.png);
                    background-position: -15% 15%, -10% 100%, 110% 60%;
                }*/
                background-repeat: no-repeat, no-repeat, no-repeat;
                @media (max-width: "576px") {
                    padding: 15% 5%;
                }
                h4 {
                    text-align: center;
                    font-size: 33px;
                    font-weight: 300;
                    color : #D0CED9;
                   /* @if $category == service {
                            color: #D0CED9;
                        }
                        @if $category == product {
                            color: #D0CED9;
                        } */
                }
                .services {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    .service {
                        width: 100%;
                        border:  5px solid #3FAB91;
                        padding: 5% 2%;
                        margin-top: 25%;
                        box-shadow: 0px 4px 10px 3px gainsboro;
                        background-color: white;
                        @if $category == service {
                            border-radius: 20px;
                        }
                        @if $category == product {
                            border-radius: 20px;
                        }
                        .service_icon {
                            display: flex;
                            justify-content: center;
                            margin-top: -20%;
                            img {
                                width: 100px;
                                height: 100px;
                                object-fit: cover;
                                border: 5px solid #3FAB91;
                                box-shadow: 0px 4px 10px 3px gainsboro;
                                background:white;
                            }
                        }
                        .service_name {
                            p {
                                text-align: center;
                                font-weight: bold;
                                font-size: 20px;
                                text-transform: uppercase;
                                color: $main_color;
                                padding: 0% 5%;
                                word-break: break-all;
                            }
                        }
                        .service_description {
                            p {
                                text-align: center;
                                color: $main_color;
                                font-weight: 500;
                                word-break: break-word;
                            }
                        }
                    }
                }
            }

            .vcard__banner_view_more_btn {
                 			width: 100%;
                            background : #3C3942;
                            border : 1px solid #3C3942;
                            box-shadow: 1px 0px 11px 1px #22CDA1;
                            &:hover{
                                background:white;
                                color:#3C3942;
                            }
            }

            .vcard__banner {
                height: 200px;
                overflow: hidden;
                i{
                    position: fixed;
                    color: black;
                    z-index: 2;
                    cursor: pointer;
                    border-radius: 7px;
                    font-size: 40px;
                } 
                .img-fluid {
                    width: 100%;
                    height: 250px;
                    object-fit: cover;
                    border-bottom-right-radius: 25px;
                    border-bottom-left-radius: 25px;
                }
                img: {
                    object-fit: cover;
                }
            }
            .vcard__profile {
                margin-top: 8%;
                background:#3C3942;
                width: 95% ;
                border-bottom-right-radius: 28px;
                border-bottom-left-radius: 28px;
                justify-content: center;
                .vcard__avatar {
                    z-index: 10;
                    width: 30%;
                    @media (max-width: "576px") {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                    }
                    img {
                        border: 5px solid #fff;
                        height: 135px;
                        min-width: 135px;
                        -o-object-fit: cover;
                        object-fit: cover;
                        width: 135px;
                    }
                }
                .vcard__position {
                    width: 35%;
                    @media (max-width: "576px") {
                        width: 100%;
                    }
                    .vcard_details {
                        margin-top: 40px;
                        margin-bottom:10%;
                        .avatar-name {
                            color: #3FAB91;
                            font-size: 18px;
                            font-weight: bold;
                            text-transform: uppercase;
                        }
                        .avatar-designation {
                            color: white;
                            font-size: 16px;
                            font-weight: 600;
                        }
                    }
                    .vcard__social {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        margin-top : 19px;
                        span {
                            color: #7D818C;
                            margin-right: 4%;
                            padding: 5px 7px 4px;
                            border: 2px solid #7D818C;
                            border-radius: 50%;
                            margin-bottom: 4%;
                            transition: all .3s ease-in-out;
                            cursor: pointer;
                            @media (max-width: "576px") {
                                padding: 6px 9px 5px 10px;
                            }
                            &:hover {
                                background-color: $main_color;
                                color: white;
                                border-color: $main_color;
                            }
                            i {
                                font-size: 20px;
                                width: 20px;
                                height: 20px;
                                @media (max-width: "576px") {
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                }
            }
            .profile_description {
                margin-top: 3%;
                h4 {
                    text-align: left;
                    color: #929197;
                    padding: 0% 5%;
                    text-transform: uppercase;
                    font-size: 35px;
                    font-weight: 600;
                    text-align: center;
                }
                p {
                    color: white;
                    text-align: left;
                    padding: 0% 5%;
                    text-align: center;
                }
            }
            .vcard__general_info {
                .contents {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .card {
                        width: 49%;
                        background-color: $main_color;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        height: 80px;
                        margin-bottom: 3%;
                        padding : 0% 2%;
                        border-radius:33px;
                        @media (max-width: "576px") {
                            width: 100%;
                        }
                        i {
                            color: #3FAB91;
                            font-size: 25px;
                            border: 2px solid  #252328;
                            box-shadow: inset 2px 4px 10px #252328;
                            padding: 8px 11px;
                            border-radius: 15px;
                            background:  #3C3F4A;
                        }
                        a {
                            color: #3FAB91;
                            margin-top: 2%;
                            padding: 0% 5%;
                            word-break: break-word;
                            font-size: 12px;
                            font-weight:500;
                        }
                    }
                }
            }
            .vcard__services {
                @include card_products_services("service");
                background-color: $main_color; 
                margin-top : 4%; 
            }
            .vcard__products {
                @include card_products_services("product");
                background-color: #3c3942;
                margin-top : 4%;
                .services {
                    .service {
                        .service_icon {
                            img {
                                border-radius: 20px;
                                object-fit: fill;
                            }
                        }
                        .service_price {
                            p {
                                color: $main_color;
                                text-align: center;
                                font-size: 40px;
                                display: flex;
                                justify-content: center;
                                .currency {
                                    font-size: 20px;
                                    margin-top: 3%;
                                    font-weight: 400;
                                }
                                .price {
                                    font-weight: bold;
                                    font-family: $number_font;
                                }
                            }
                        }
                    }
                }
            }
            .vcard__qr_code {
                padding: 3% 24%;
                .title_qr_code{
                    color:#D0CED9;
                    text-align:center;
                    font-weight: 300;
                    font-size: 33px;
                    
                }
                .boxShadow {
                    /*box-shadow: 6px 6px 7px 0px $main_color;*/
                    margin: 0% 5%;
                    padding: 1% 1%;
                    border-radius: 10px;
                    .contents {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        padding: 13% 0%;
                        border: 3px solid $main_color;
                        border-radius: 20px;
                        align-items:center;
                        background-color:#3C3942;
                        .content {
                            width: 50%;
                            display: flex;
                            justify-content: center;
                            @media (max-width: "576px") {
                                width: 100%;
                                margin-top: 15%;
                            }
                           /* img {
                                width: 80px;
                                height: 90px;
                                object-fit: cover;
                                box-shadow: 0 0 0 6px white, 0 0 0 8px $main_color,
                            }*/
                        }
                    }
                }
            }
            .vcard__working_hours {
                h4 {
                    font-size: 33px;
                    text-align: center;
                    margin-bottom: 5%;
                    color: #D0CED9;
                    font-weight: 300;
                }
                .contents {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    color:#22CDA1;
                    padding:2% 2%;
                    p {
                        width: 45%;
                        @media (max-width: "576px") {
                            width: 100%;
                        }
                        display: flex;
                        justify-content: space-between;
                        .day {
                            font-weight: bold;
                            width: 40%;
                        }
                        .dot {
                            width: 10%;
                        }
                        .hour {
                            width: 50%;
                        }
                    }
                }
            }
            .vcard__catalogue {
                margin-top : 4%;
                h4 {
                    font-size: 33px;
                    text-align: center;
                    margin-bottom: 5%;
                    color: #D0CED9;
                    font-weight: 300;
                }
                .catalgueListBtn {
                    a {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        button {
                            width: 40%;
                            background : #3C3942;
                            border : 1px solid #3C3942;
                            box-shadow: 1px 0px 11px 1px #22CDA1;
                            &:hover{
                                background:white;
                            }
                        }
                    }
                }
                .contents {
                    .content {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        position: relative;
                        border: 2px solid #3FAB91;
                        margin: 5% 35%;
                        @media (max-width: "576px") {
                            margin: 5% 10%;
                        }
                        padding: 3%;
                        border-radius: 20px;
                        p {
                            font-weight: bold;
                            width: 100%;
                            text-align: center;
                            color: #3FAB91 ;
                        }
                        i {
                            font-size: 40px;
                            cursor: pointer;
                            transition: color .3s ease-in-out;
                            &:hover {
                                color: #D0CED9;
                            }
                        }
                    }
                }
            }
            .vcard__contact {
                h4 {
                    font-size: 40px;
                    text-align: center;
                    margin-bottom: 5%;
                    color:#D0CED9;
                    font-weight: 300; 
                }
                .formContents {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .form-group {
                        width: 100%;
                        .forminput{
                            display: block;
                            width: 100%;
                            padding: 0.5rem 0.75rem;
                            font-size: 0.875rem;
                            font-weight: 400;
                            line-height: 1.4rem;
                            color: #495057;
                            background-color: #2E2834;
                            border: 1.5px solid #2B8E7B;
                        }
                    }
                    .btnList {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        flex-wrap: wrap;
                        button {
                            width: 100%;
                            color: #2B2531;
                            font-size: 16px;
                            font-weight: 500;
                            background:#7F838E;
                            @media (max-width: "576px") {
                                width: 100%;
                            }
                            i{
                               color: #2B2531;
                               font-size: 24px;
                            }
                        }
                    }
                }
            }
            .copyright {
                position: relative;
                .line {
                    background-color: #bfc1c1;
                    width: 100%;
                    height: 2px;
                    position: absolute;
                    top: 0;
                }
                p {
                    text-align: center;
                    color: #F9F9E0;
                }
            }
        }
    }
</style>
